var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"padding":"20px"},attrs:{"fluid":""}},[_c('v-list',{staticClass:"c-grey text-left"},_vm._l((_vm.basicListArray),function(item){return _c('v-list-item',{key:item},[_vm._v("\n        "+_vm._s("•  " + item)+"\n        ")])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72cf966a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BasicList.vue
// module id = 1012
// module chunks = 0